export default __webpack_public_path__ + "static/media/avatar.493b2b98.jfif";